export default {
  namespaced: true,
  state: {
    personalidades: [],
    funcionalidades: [],
    calltoactions: [],
    propositos: [],
  },
  mutations: {
    setDataPersonalidades (state, payload) {
      state.personalidades = payload
    },
    setDataFuncionalidades (state, payload) {
      state.funcionalidades = payload
    },
    setDataCallToActions (state, payload) {
      state.calltoactions = payload
    },
    setDataPropositos (state, payload) {
      state.propositos = payload
    },
  }
}